import BreadCrumbs from 'components/breadcrumbs'
import { Card, CardBody } from 'reactstrap'
import { useDispatch, useSelector } from 'react-redux'

import { useFetchAttendanceSummaryQuery } from './attendanceSummaryApiSlice'

import TableSummary from './TableSummary'
import { useEffect } from 'react'
import { setFetchOption } from './attendanceSummarySlice'

const AttendanceSummary = () => {
  const dispatch = useDispatch()
  const { tag } = useSelector((s) => s.attendanceSummary)
  const queryTag = tag
    ? Object.fromEntries(
        Object.entries(tag).filter(([key]) => key !== 'memberUserId'),
      )
    : {}

  const res = useFetchAttendanceSummaryQuery(
    {
      ...queryTag,
    },
    { skip: !tag },
  )

  useEffect(() => {
    dispatch(
      setFetchOption({
        s: undefined,
      }),
    )
  }, [])

  return (
    <div className="w-100 px-3">
      <div className="d-flex align-items-start gap-2 pt-3">
        <BreadCrumbs breadCrumbActive={'Ringkasan'} />
      </div>
      <div className="d-flex flex-column gap-2 mb-2">
        <Card className="border-0 shadow-sm">
          <CardBody>
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h5>Ringkasan Per Karyawan Per Bulan</h5>
            </div>

            <TableSummary res={res} />
          </CardBody>
        </Card>
      </div>
    </div>
  )
}

export default AttendanceSummary
